var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2612_19615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.174 13.0001C25.174 6.27661 19.7236 0.826172 13.0001 0.826172C6.27661 0.826172 0.826172 6.27661 0.826172 13.0001C0.826172 19.0763 5.27797 24.1128 11.0979 25.0261V16.5191H8.00688V13.0001H11.0979V10.318C11.0979 7.26693 12.9154 5.58161 15.6962 5.58161C17.0277 5.58161 18.4213 5.81938 18.4213 5.81938V8.8153H16.8862C15.374 8.8153 14.9023 9.75379 14.9023 10.7175V13.0001H18.2786L17.7389 16.5191H14.9023V25.0261C20.7222 24.1128 25.174 19.0763 25.174 13.0001Z",
    fill: "#290064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2612_19615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.3478,
    height: 24.3478,
    fill: "white",
    transform: "translate(0.826172 0.826172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5be9d0283a8c2434cf7ff3c9c90d3529.svg";
export { ForwardRef as ReactComponent };